import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Features from "./../components/Features/Features";
import { ToastContainer, toast } from "react-toastify";
import { XMarkIcon } from "@heroicons/react/24/outline";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import validator from "email-validator";

const Landing = () => {
  const [creators, setCreators] = useState([]);
  const variants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px", // Triggers as soon as the element comes within 100px of the viewport
  });
  const [logoRef, logoInView] = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px", // Adjust this value if you want it to trigger at a different point
  });
  const [creatorRef, creatorInView] = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px", // Adjust this value if you want it to trigger at a different point
  });
  const [waitlistRef, waitlistInView] = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px", // Adjust this value if you want it to trigger at a different point
  });
  

  // get clients api
  //https://eiqk77oybg3zkn72q5g3ltimzu0jpinj.lambda-url.eu-north-1.on.aws/
  async function callGetCreatorsAPI() {
    try {
      const options = {
        url: `https://eiqk77oybg3zkn72q5g3ltimzu0jpinj.lambda-url.eu-north-1.on.aws/`,

        method: "POST",
      };
      console.log(options, "mai axios opt hu");
      const response = await axios(options);
      console.log("creators list", response?.data?.clients);
      setCreators(response?.data?.clients);
    } catch (err) {
      console.log(err);
    }
  }
  const [showStartup, setShowStartup] = useState(true);

  //Email modal
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleJoinWaitlistClick = () => {
    try {
      setShowModal(true);
    } catch (err) {
      console.log(err, "error message");
    }

    // api call to store email
  };

  const handleSubmit = async (event) => {
    if(validator.validate(email)){
        try {
            event.preventDefault();
            console.log(email);
            setEmail("");
      
            // remeber to replace with nvironment variabke
            const options = {
              url: `https://jrcaz6pgvcrim5tcgj3bvdq2mu0klghj.lambda-url.eu-north-1.on.aws?email=${email}`,
              data: { email },
              method: "POST",
            };
            console.log(options, "mai axios opt hu");
            const response = await axios(options);
            console.log("mai response hu", response);
            setShowModal(false);
            toast(
              "Thanks for dropping your email! 🚀 Get ready for some awesomeness. Hang tight for 10 minutes and keep an eye on your inbox! Our squad will slide into your DMs shortly. Stay tuned! ✨"
            );
          } catch (err) {
            console.log(err);
          }
    }
    else{toast("Please enter a valid email address")}
    
  };

  useEffect(() => {
    callGetCreatorsAPI();
  }, []);
  // Animation variants for the AI-powered suite
  const suiteVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeOut" },
    },
    hidden: { opacity: 0, y: 50 },
  };
  const creatorVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeOut" },
    },
    hidden: { opacity: 0, y: 50 },
  };
  const logoVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeOut" },
    },
    hidden: { opacity: 0, y: 50 },
  };
  const waitlistVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeOut" },
    },
    hidden: { opacity: 0, y: 50 },
  };

  return (
    <div className="overflow-none bg-blue-100 min-h-screen">
      {showStartup && (
        <motion.div
          className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white"
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ delay: 1, duration: 1 }}
          onAnimationComplete={() => setShowStartup(false)}
        >
          <motion.div
            className="flex flex-col items-center"
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <motion.h1
              className="text-[#7C82FF] text-6xl font-bold mb-4"
              style={{ fontFamily: "Helvetica Neue, sans-serif" }}
            >
              AINA
            </motion.h1>
          </motion.div>
        </motion.div>
      )}
      {!showStartup && (
        <div
          className=" relative bg-white bg-no-repeat bg-cover bg-center h-full"
          style={{
            backgroundImage: "url(/background.svg)",
            backgroundAttachment: "fixed",
          }}
        >
          <Navbar />

          <div
            className="flex justify-center items-center h-full mt-12 mb-16"
            id="Home"
          >
            {/* Flex container changes direction based on screen size */}
            <div className="flex flex-col sm:flex-row w-full max-w-6xl mx-auto">
              {/* Text container with responsive horizontal padding */}
              <div className="flex flex-col w-full sm:w-1/2 justify-center items-start px-6 sm:px-12 py-4 space-y-2 sm:space-y-4">
                <motion.h1
                  className="text-5xl sm:text-7xl font-bold mb-2 text-left leading-tight"
                  variants={variants}
                  initial="hidden"
                  animate="visible"
                  transition={{ duration: 2.5, ease: "easeOut" }}
                >
                  <span className="text-black mr-2 font-poppins">Meet</span>
                  <span className="text-[#7C82FF] font-poppins">AINA</span>
                </motion.h1>
                <motion.div
                  className="space-y-2 sm:space-y-4"
                  initial="hidden"
                  animate="visible"
                  variants={variants}
                  transition={{ staggerChildren: 0.3 }}
                >
                  <motion.p
                    className="text-gray-900 text-2xl sm:text-3xl font-poppins font-medium text-left"
                    variants={variants}
                    transition={{ duration: 2.5, ease: "easeOut" }}
                  >
                    The{" "}
                    <span className="font-bold">
                      Digital Avatars of your favorite Creators{" "}
                    </span>
                    .
                  </motion.p>
                  <motion.p
                    className="text-gray-600 text-xl sm:text-3xl font-poppins font-medium text-left"
                    variants={variants}
                    transition={{ duration: 2.5, ease: "easeOut" }}
                  >
                    Get started for free to DM Your Faves:
                  </motion.p>
                  <motion.p
                    className="text-gray-600 text-xl sm:text-3xl font-poppins font-medium text-left"
                    variants={variants}
                    transition={{ duration: 2.5, ease: "easeOut" }}
                  >
                    All Things, All Time, All Places
                  </motion.p>
                  <motion.div
                    variants={variants}
                    transition={{ duration: 2.5, ease: "easeOut" }}
                    className="flex justify-start mt-2"
                  >
                    <a
                      href="https://discord.gg/6UnCj97DFN"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="bg-[#7C82FF] text-white border-2 border-[#7C82FF] hover:bg-white hover:text-[#7C82FF] font-semibold py-2 px-10 rounded-lg transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-[#7C82FF]">
                        Join our Discord!
                      </button>
                    </a>
                  </motion.div>
                </motion.div>
              </div>

              {/* Image container with responsive classes for display and horizontal padding */}
              <div className="hidden sm:flex justify-center items-center w-full sm:w-1/2 px-6 sm:px-12 py-4">
                <motion.img
                  src="/bot.png"
                  alt="Chatbot"
                  className="object-contain sm:object-cover w-full h-auto"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 3 }} // Duration of the animation in seconds
                />
              </div>
            </div>
          </div>
          <motion.div
            className="flex justify-center items-center w-full px-4 mt-12 mb-16"
            variants={variants}
            initial="hidden"
            animate="visible"
            transition={{ duration: 2.5, ease: "easeOut", delay: 1 }}
          >
            <div className="w-full max-w-6xl aspect-video rounded-xl overflow-hidden">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/Qewg9aEDJZ4?si=MxPtyuYsyUpHMBe1" // Link to a mock video
                title="Video Title"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </motion.div>
          <div className="flex flex-col justify-center items-center h-full text-center px-4 sm:px-0">
            <motion.h1
              className="text-4xl sm:text-5xl font-bold mt-6 sm:mt-12 mb-4"
              variants={suiteVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              ref={ref}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <span className="text-black mr-2 font-poppins">Unlock the</span>
              <span className="text-[#7C82FF] font-poppins">Knowledge</span>
            </motion.h1>
            <motion.h2
              className="text-3xl text-black sm:text-4xl font-bold mb-6 font-poppins"
              variants={suiteVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              ref={ref}
              transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
            >
              of Trusted Creators
            </motion.h2>
            <motion.p
              className="text-black text-lg sm:text-2xl mb-8 font-poppins font-medium"
              variants={variants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              ref={ref}
              transition={{ duration: 2.5, ease: "easeOut", delay: 0.6 }}
            >
              <button
                onClick={handleJoinWaitlistClick}
                className="bg-[#7C82FF] text-white border-2 border-[#7C82FF] hover:bg-white hover:text-[#7C82FF] font-semibold py-2 px-10 rounded-lg transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-[#7C82FF]"
              >
                Get started for free
              </button>
            </motion.p>
            <motion.div
              className="animate-bounce"
              variants={variants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              ref={ref}
              transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
            ></motion.div>
          </div>
          <div id="Avatars" className="mt-10 xl:mx-48 mb-24 md:mx-32 md:block flex justify-center items-center">
            <motion.div
              className="md:grid grid-cols-2 md:gap-32 gap-4 flex flex-col"
              variants={creatorVariants}
              initial="hidden"
              animate={creatorInView ? "visible" : "hidden"}
              ref={creatorRef}
              transition={{ duration: 1, ease: "easeOut", delay: 1 }}
            >
              {creators.map((creator) => {
                return (
                  <>
                    <div class="bg-[#59569f] sm:h-[30rem] h-[25rem]    rounded-lg  ">
                      <a href="#">
                        <img
                          class="rounded-t-lg h-4/5 w-full"
                          src={creator?.img}
                          alt=""
                        />
                      </a>
                      <div class="p-5  ">
                        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white ">
                          {creator?.name}
                        </h5>
                      </div>
                    </div>
                  </>
                );
              })}
            </motion.div>
          </div>
          <div id="Features">
            <Features />
            </div>
          

          <motion.div
            className="flex flex-col justify-center items-center h-full text-center"
            variants={logoVariants}
            initial="hidden"
            animate={logoInView ? "visible" : "hidden"}
            ref={logoRef}
            transition={{ duration: 1, ease: "easeOut" }}
          >
           
          </motion.div>

          {/*waitlist*/}
          <motion.div
            variants={waitlistVariants}
            id="JoinOurDiscord"
            initial="hidden"
            animate={waitlistInView ? "visible" : "hidden"}
            ref={waitlistRef}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <h1 className="text-4xl sm:text-5xl font-bold mt-12">
              <span className="text-white mr-2 font-poppins">
                Join our Discord
              </span>
            </h1>
            <a
              href="https://discord.gg/6UnCj97DFN"
              target="_blank"
              rel="noreferrer"
            >
              <button className="bg-[#7C82FF] mt-4 border-[#7C82FF] border-2 hover:bg-[#32325D] hover:text-white text-white font-semibold py-2 px-10 rounded-lg transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#4F4484] focus:ring-white">
               Join Discord!
              </button>
            </a>
          </motion.div>
          <Footer />
        </div>
      )}
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-auto bg-smoke-light flex">
          <div className="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-lg shadow-lg">
            <div className="flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="text-[#7C82FF] rounded-md p-1.5 inline-flex items-center justify-center hover:bg-[#ebedff] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7C82FF]"
              >
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                <span className="sr-only">Close</span>
              </button>
            </div>
            <form
              onSubmit={handleSubmit}
              className="mt-4 sm:mt-6 flex flex-col space-y-4"
            >
              <div>
                <label
                  htmlFor="email"
                  className="text-lg font-bold text-[#32325D] block"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded mt-1 focus:ring-[#7C82FF] focus:border-[#7C82FF]"
                />
              </div>
              <button
                type="submit"
                className="bg-[#7C82FF] text-white font-bold py-2 px-4 rounded hover:bg-[#5a5fcf] transition ease-in-out duration-300"
              >
                Join Waitlist
              </button>
            </form>
          </div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{
          maxWidth: "600px",
        }}
        progressStyle={{
          background: "#7C82FF",
        }}
      />
    </div>
  );
};

export default Landing;
